import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function RatingIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M15.3199 12.7907L18.1637 10.0188L14.2336 9.44777C14.0633 9.42297 13.9155 9.31607 13.8393 9.16135L12.0819 5.6L10.3244 9.16134C10.2482 9.31606 10.1004 9.42296 9.93011 9.44777L6 10.0188L8.84376 12.7907C8.96753 12.9109 9.02379 13.0843 8.99464 13.2544L8.32308 17.1684L11.8379 15.3204C11.9903 15.2401 12.1729 15.2401 12.3253 15.3204L15.8406 17.1684L15.1691 13.2544C15.1399 13.0843 15.1962 12.9109 15.3199 12.7907Z",
    fill: "currentColor"
  }));
}